import clsx from 'clsx';
import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'tertiary';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: React.ReactNode;
  className?: string;
}

const sizeClassMap: Record<ButtonSize, string> = {
  sm: 'px-3 py-1 text-sm font-semibold',
  md: 'px-4 py-1 text-base font-semibold',
  lg: 'px-6 py-2 text-lg font-bold',
};

const variantClassMap: Record<ButtonVariant, string> = {
  primary:
    'bg-color-bg-primary text-color-text-inverse hover:bg-color-bg-primary-hover active:bg-color-bg-primary-active disabled:bg-color-bg-primary-disabled',
  secondary: 'text-color-bg-primary border-2 border-color-primary disabled:opacity-70',
  tertiary: 'text-color-bg-primary disabled:opacity-70',
};

export const GCashButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', children, className, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={clsx(
          'focus-visible:ring-color-bg-primary flex-1 rounded-full tracking-wide transition-colors focus:outline-none focus-visible:ring-2',
          variantClassMap[variant],
          sizeClassMap[size],
          className
        )}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

GCashButton.displayName = 'GCashButton';
